// Saga

export function login(
    email: string,
    password: string
): sage.actions.user.ILogin {
    return {
        type: "com.sage.actions.user.ILogin",
        email,
        password,
    };
}

export function signOut(): sage.actions.user.ISignOut {
    return {
        type: "com.sage.actions.user.ISignOut",
    };
}

export function loadTokenFromStorage(): sage.actions.user.ILoadTokenFromStorage {
    return {
        type: "com.sage.action.user.ILoadTokenFromStorage",
    };
}

export function fetchUser(): sage.actions.user.IFetchUser {
    return {
        type: "com.sage.actions.user.IFetchUser",
    };
}

export function signUp(
    email: string,
    password: string
): sage.actions.user.ISignUp {
    return {
        type: "com.sage.actions.user.ISignUp",
        email,
        password,
    };
}

export function fetchStripeAccountLinks(): sage.actions.user.IFetchStripeAccountLinks {
    return {
        type: "com.sage.actions.user.IFetchStripeAccountLinks",
    };
}

export function sendResetPassword(
    email: string
): sage.actions.user.ISendResetPassword {
    return {
        type: "com.sage.actions.user.ISendResetPassword",
        email,
    };
}

export function resetPassword(
    password: string,
    code: string,
    email: string
): sage.actions.user.IResetPassword {
    return {
        type: "com.sage.actions.user.IResetPassword",
        password,
        code,
        email,
    };
}

export function submitFeedback(
    email: string,
    content: string
): sage.actions.user.ISubmitFeedback {
    return {
        type: "com.sage.actions.users.ISubmitFeedback",
        email,
        content,
    };
}

// Redux

export function setLoginStatus(
    status: "loading" | "none" | "error" | "unauthorized"
): sage.actions.user.ISetLoginStatus {
    return {
        type: "com.saga.actions.user.ISetLoginStatus",
        status,
    };
}

export function setLoadTokenStatus(
    status: "loading" | "none"
): sage.actions.user.ISetLoadTokenStatus {
    return {
        type: "com.sage.actions.user.ISetLoadTokenStatus",
        status: status,
    };
}

export function setAccessToken(
    accessToken: string
): sage.actions.user.ISetAccessToken {
    return {
        type: "com.sage.actions.user.ISetAccessToken",
        accessToken,
    };
}

export function clear(): sage.actions.user.IClear {
    return {
        type: "com.sage.actions.user.IClear",
    };
}

export function setUser(user: sage.model.IUser): sage.actions.user.ISetUser {
    return {
        type: "com.sage.actions.jobs.ISetUser",
        user: user,
    };
}

export function setFetchUserStatus(
    status: "loading" | "none" | "error"
): sage.actions.user.ISetFetchUserStatus {
    return {
        type: "com.sage.actions.user.ISetFetchUserStatus",
        status,
    };
}

export function setSignUpStatus(
    status:
        | "loading"
        | "none"
        | "error"
        | "passwords_dont_match"
        | "email_exists"
): sage.actions.user.ISetSignUpStatus {
    return {
        type: "com.sage.actions.user.ISetSignUpStatus",
        status,
    };
}

export function setStripeAccountLinksStatus(
    status: sage.status.StripeAccountLinkStatus
): sage.actions.user.ISetStripeAccountLinksStatus {
    return {
        type: "com.sage.actions.user.ISetStripeAccountLinksStatus",
        status,
    };
}

export function setStripeAccountLinks(
    accountLinks: sage.model.IStripeAccountLink
): sage.actions.user.ISetStripeAccountLinks {
    return {
        type: "com.sage.actions.user.ISetStripeAccountLinks",
        accountLinks,
    };
}

export function setSendResetPasswordStatus(
    status: sage.status.SendResetPassword
): sage.actions.user.ISetSendResetPasswordStatus {
    return {
        type: "com.sage.actions.user.ISetSendResetPasswordStatus",
        status,
    };
}

export function setResetPasswordStatus(
    status: sage.status.ResetPassword
): sage.actions.user.ISetResetPasswordStatus {
    return {
        type: "com.sage.actions.user.ISetResetPasswordStatus",
        status,
    };
}

export function setSubmitFeedbackStatus(
    status: sage.status.SubmitFeedbackState
): sage.actions.user.ISetSubmitFeedbackStatus {
    return {
        type: "com.sage.actions.users.ISetSubmitFeedbackStatus",
        status,
    };
}
